import React, { Component } from 'react'
import { Card, Button, Row, Col, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Select1 from 'react-select';
import { dataCoberturas } from 'redux/selectors/sPymes'
import NumberFormat from 'react-number-format';

class LucroCesante extends Component {
    constructor(props) {
        super(props)
        const generales = {
            numPersonas: 0,
            sumaAsegurada: 0,
            gastosMedicos: 0,
            gastosSepelio: 0,
            gastosAmbulancia: 0
        }
        this.state = { guardar: false, generales, estadoGenerales: false, cobGenerales: [], cambiaData: 'btn btn-primary', hasError: true, valorSeleccionado: null }

    }
    handleClick = async (datos, i, siguiente) => {
        const { idCobertura } = this.props
        let { guardar, generales } = this.state


        const res = await this.props.guardarCobertura({ arrayData: [], idCobertura, generales })

        let ubicaciones = []
        let { cobGenerales } = this.state

        if (res.transaccion) {
            ubicaciones = res.ubicaciones
            generales = res.generales
            //cobGenerales = res.limites
            guardar = true
        } else {
            guardar = this.state.guardar
        }

        this.setState({ guardar, generales, cobGenerales, cambiaData: 'btn btn-primary' })

        if (!guardar) window.scroll(0, 0)
    }
    componentDidMount() {
        const { cobGenerales } = this.props
        let generales = cobGenerales.reduce((i, { codigo }) => ({ ...i, [codigo]: 0 }), {})
        this.setState({ cobGenerales, generales })

        if (!this.state.valorSeleccionado) {
            this.setState({ hasError: true })
        }
    }
    handleBack = () => {
        this.props.handleAtras()
    }

    handleGenerales = (valor, codigo, maximo, generales, objeto) => {

        if (Array.isArray(maximo)) {
            generales = { ...generales, [codigo]: valor }

            this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse', valorSeleccionado: objeto })


        } else {
            valor = parseFloat(valor)
            if (isNaN(valor)) valor = 0
            if (valor >= 0) {
                maximo = parseFloat(maximo)
                if (valor <= maximo || maximo == -1) {
                    generales = { ...generales, [codigo]: valor }
                    this.setState({ generales, cambiaData: 'btn btn-purple fe-pulse' })
                }
            }
        }

        if (!generales.periodoDeIndemnizacion
        ) {

            this.setState({ hasError: true })
        } else {
            console.log('asdsadasd2')
            this.setState({ hasError: false })
        }




    }
    componentDidUpdate(prevProps, prevState) {
        const { cobGenerales } = this.props
        if (cobGenerales !== prevProps.cobGenerales) this.setState({ cobGenerales })

    }

    render() {

        const { generales, cobGenerales, cambiaData } = this.state
        const { titulo, nombreGiro, idCobertura } = this.props

        return (
            <Col md={8}>
                <div className='row' style={{ background: '#e8eaed', margin: 'auto', padding: 10, marginBottom: 10, }}>
                    <Col sm={6}> <h3 style={{ fontWeight: 700, color: '#b6207f', }}>{titulo}</h3> <div style={{}}> Por favor ingrese los valores que desea asegurar </div> </Col>
                    <Col sm={6} style={{ borderLeft: '2px solid #b3b4b6', }} > <h3 style={{ fontWeight: 700, }}> <center> Giro del negocio: </center> </h3> <div style={{ fontSize: '1.3rem', }}> <center> {nombreGiro} </center> </div>  </Col>
                </div>


                <div className='row card'>
                    <Col md={12} className='card-body' style={{ background: '#fff', }}>
                        <div className='flex' style={{ justifyContent: 'space-between', }}>
                            <label style={{ fontWeight: 700, }}> Coberturas Generales: </label>
                            <label style={{ color: '#909090', }}>Valor Máximo</label>
                        </div>
                        {cobGenerales && cobGenerales.map(({ codigo, descripcion, valor }, i) =>
                            !Array.isArray(valor) ?


                                <Row key={'coberGenerales' + i + codigo}>
                                    <Col xs={6} sm={4} > <p>{descripcion}</p> </Col>
                                    <Col xs={6} sm={5}>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={idCobertura == 'transporteInterno'
                                                && ((codigo == 'transporteInternoEstimadoTodoRiesgo'
                                                    && (!generales.opcion || generales.opcion == 'usada'))
                                                    || codigo == 'transporteInternoEstimadoLAP'
                                                    && (!generales.opcion || generales.opcion == 'nueva'))}
                                            style={{ width: 'inherit', fontSize: 20, textAlign: 'right', }}
                                            value={generales[codigo] ? generales[codigo] : 0}
                                            thousandSeparator={','}
                                            decimalSeparator={'.'}
                                            decimalScale={2}
                                            prefix={''}
                                            onValueChange={(_valor, e) => {
                                                console.log("ONCHANGE",_valor, e)

                                                this.handleGenerales(_valor.floatValue, codigo, valor, generales, _valor.floatValue)
                                            }}

                                        />
                                    </Col>
                                    <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', }}>{valor != -1 ? valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : null}</p> </Col>
                                </Row>

                                :

                                <Row key={'coberGenerales' + i + codigo}>
                                    <Col xs={6} sm={4} > <p>{descripcion}</p> </Col>
                                    <Col xs={6} sm={5}>
                                        <Select1
                                            placeholder={'Seleccione un elemento'}
                                            onFocus={() => this.setState({ valorSeleccionado: valor.length > 0 ? listSlct1(valor)[0] : null })}
                                            options={listSlct1(valor)}
                                            value={
                                                this.state.valorSeleccionado
                                            }

                                            onChange={
                                                (value, e) => {
                                                    this.handleGenerales(value.value, codigo, valor, generales, value)
                                                }
                                            }

                                            validationOption={{
                                                name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                msgOnError:
                                                    "Por favor seleccione " + descripcion,
                                            }}
                                        />

                                        {idCobertura == 'transporteInterno' && codigo == 'riesgo' ?
                                            <h5>En caso de que la mercadería transportada no se encuentre detallada en el listado, por favor contactarse su ejecutivo de AIG</h5>

                                            : null}


                                    </Col>

                                    <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', }}></p> </Col>
                                </Row>
                        )}
                    </Col>
                    <div className='flex' style={{ margin: 10, }}  >
                        <Button className="btn btn-detail-gray" onClick={() => this.handleBack()} style={{ margin: "auto" }} >
                            <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                        </Button>
                        <Button disabled={this.state.hasError || this.state.generales.lucroCesantePorIncendio > this.state.generales.utilidadBruta} className={cambiaData} onClick={() => { /*setValidate(true);*/ this.handleClick([], 0, false) }} style={{ margin: "auto", }} >
                            <i className="fa fa-chevron-circle-right " aria-hidden="true" />{' ACTUALIZAR VALORES'}
                        </Button>
                    </div>
                </div>

                {this.state.generales.lucroCesantePorIncendio > this.state.generales.utilidadBruta && <div className='row card'>
                    <Col md={12} className='card-body' style={{ background: '#fff', }}>
                        <label style={{ fontWeight: 700, }}> Nota: </label>

                        {this.state.generales.lucroCesantePorIncendio > this.state.generales.utilidadBruta && <p >Lucro Cesante por Incendio no debe ser mayor a Utilidad bruta </p>}




                    </Col>
                </div>}



            </Col >
        )
    }
}

const listSlct1 = (list) => {
    const formatList = []
    for (const idx in list) {

        formatList.push({
            value: list[idx]['claveOpcion'] || list[idx]['nivelRiesgo'],
            label: list[idx]['textoOpcion'] || list[idx]['tipoRiesgo']
        })
    }


    // return
    return formatList
}
const mapStateToProps = (state, props) => ({
    //coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(LucroCesante)
);